<template>
  <div id="inside" style="" :style="largura > 500 ? 'min-height: 685px;': 'min-height: 480px;'">
    
   <div class="container">
     <div class="row" >
       <div class="">
       </div>
       <div class="btn-group btn-group-sm">
           <a
             href="/"
             class="btn btn-link d-flex flex-column justify-content-center text-secondary"
             ><i class="fa fa-home fa-fw fa-lg"></i
           ></a>
           <router-link
             to="/dashboard"
             ><a class="btn btn-link text-secondary">Meus contratos</a>
           </router-link>
           <router-link
             to="#"
             ><a href="#" class="btn btn-link text-secondary" style="text-decoration: none; cursor: initial;">Meus boletos ativos</a>
           </router-link>
       </div>
       <div class="col-md-12">
           <h1>Meus boletos ativos</h1>
           <div 
           v-if="!loadDeal && (isEmpty(responseFromAgreement) && contracts.length === 0 && contractsInvoices.length === 0)"
           class="d-inline-flex flex-wrap flex-column text-danger col-lg-5 col-md-5 col-acao">
           Não foram encontrados boletos ativos.
           </div>
           <p 
           v-else
           class="text-muted">Pague os boletos abaixo até as datas de vencimento.</p>
       </div>
     </div>
   </div>
   <ProgressLoading v-bind:loading="loadDeal" />
   <div class="container" v-if="!loadDeal">
     <div class="col-lg-12 pl-0 mb-3">
         <p class="text-info mb-0 mt-2"> Documento: {{ formatDocument(user.DocNumber) }}</p>
       </div>
       <!-- <pre> {{ showOtherContracts }} </pre> -->
       <!-- <pre> {{ responseFromAgreement }} </pre> -->
     <button v-if="!loadDeal && (contracts.length !== 0 || contractsUpdated !== null || contractsInvoices !== null)" type="button" style="background-color: gray;" 
       class="btn text-white btn-lg col-7 col-md-4 col-lg-3"
       @click="showOthersBilss()">{{ showOtherContracts ? "Retornar aos meus boletos" : "Mostrar todos os boletos" }}
     </button>
     <div class="col-lg-12 pl-0" style="" >
         <a v-bind:class="[ largura < 500 ? 'btn btn-lg btn-primary col-3 col-md-12 col-lg-1 mt-3 text-white': 'btn btn-lg btn-primary col-12 col-md-12 col-lg-1 mt-3 text-white' ]"  class="" 
         @click="voltar" 
         style="cursor: pointer;">Voltar</a>
     </div>
     <div class="row m-2 justify-content-center">
       

         <div class="d-flex-center flex-wrap flex-column col-lg-7">
          <div v-if="!showOtherContracts">
           <div v-for="(value, key, index) in contracts"
                           :key="`${key}-${index}`">
             <div class="card" v-if="value.parcelas.length > 0">
               <div class="card-header">
                 <i class="fa fa-fw mr-2 fa-circle text-warning"></i>
                 Boleto ativo
               </div>
               <div class="card-body" >
                   <div class="row" v-for="(installment, key2, index2) in value.parcelas"
                               :key="`${key2}-${index2}`">
                     <div class="col-md-12">
                       <h6 class="col">Acordo: {{ value.contrato }}</h6>
                       <div class="row col-12 align-items-center justify-content-end">
                         <div class="col-md-12 col-lg-8">
                           <p class="m-0 text-info">Vencimento:</p>
                           <h6>{{ formatData(installment.vencimento, 'YYYY-MM-DD', 'L') }}</h6>
                         </div>
                         <div class="col-lg-4 col-12 align-self-end">
                           <p>Valor: R$ {{ installment.valor  }}</p>
                         </div>
                         <a class="btn mr-1 mb-1 btn-outline-primary btn-block" href="#" v-if="!(loadInstallment && installment.valor === valorParcela)" @click="buildNewBill(value, key, installment, true)" ><i class="fa fa-download fa-fw"></i>&nbsp;Baixar boleto</a>
                         <ProgressLoading v-bind:loading="loadInstallment && installment.valor === valorParcela" />
                       </div>
                       <hr>
                     </div>
                   </div>
               </div>  
             </div>
           </div>
           </div>
           <!-- <pre>{{ 'contracts ' + JSON.stringify(contracts.length) }}</pre>
           <pre>{{ 'contractsUpdated X' + JSON.stringify(contractsUpdated) }}</pre>
           <pre>{{ 'contractsValidateDate X' + JSON.stringify(contractsValidateDate) }}</pre>
           <pre>{{ 'onlyContractsSecondInvoice X' + JSON.stringify(onlyContractsSecondInvoice) }}</pre>
           <pre>{{ 'responseFromAgreement ' + JSON.stringify(responseFromAgreement.length) }}</pre>
           <pre>{{ 'datePlusDocIsSmallerThan30Days X' + datePlusDocIsSmallerThan30Days(this.contractsInvoices[0].Vencimento.split('T')[0]) }}</pre>
           <pre>{{ 'showOtherContracts X' + showOtherContracts }}</pre>
           <pre>{{ 'dateIsBetweenSixAnd67Days ' + dateIsBetweenSixAnd67Days(contractsValidateDate.length > 0 ? contractsValidateDate[0].parcelas[0].vencimento : null) }}</pre> 
           <pre>{{ 'dateIsBetweenSixAnd67Days ' + dateIsBetweenSixAnd67Days(contracts.length > 0 ? contracts[0].parcelas[0].vencimento : null) }}</pre>  -->

           

           <div v-if="this.contractsInvoices.length > 0">
           <div v-if="contractsInvoices !== null && showOtherContracts && contractsUpdated === null && datePlusDocIsSmallerThan30Days(this.contractsInvoices[0].Vencimento.split('T')[0]) && contractsValidateDate.length <= 0 && contracts.length <= 0">
           <div v-for="(value, key, index) in contractsInvoices"
                           :key="`${key}-${index}`">
                           <div class="card">
               <div class="card-header">
                 <i class="fa fa-fw mr-2 fa-circle text-warning"></i>
                 Boleto ativo
               </div>
               <div class="card-body">
                   <div class="row">
                     <div class="col-md-12">
                       <h6 class="col">Acordo: {{ value.Contrato }}</h6>
                       <div class="row col-12 align-items-center justify-content-end">
                         <div class="col-md-12 col-lg-8">
                           <p class="m-0 text-info">Vencimento:</p>
                           <h6>{{ formatData(value.Vencimento, 'YYYY-MM-DD', 'L') }}</h6>
                         </div>
                         <div class="col-lg-4 col-12 align-self-end">
                           <p>Valor: {{ parseFloat(value.ValorDocumento, 10).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</p>
                         </div>
                        <div class="text-info mb-1 col-12">
                          <div v-if="value.DigitableLine">
                         <p >Linha digitável:</p>
                         <p class="codebar col-12" id="linhaDigitavel">{{ value.DigitableLine }}</p>
                         <a class="btn mr-1 mb-1 btn-outline-primary btn-block" href="#" @click="copiarLinhaDigitável(value.DigitableLine)"><i class="fa fa-copy fa-fw"
                         @click="copiarLinhaDigitável(value.DigitableLine)"></i>&nbsp;Copiar linha digitável</a>
                         <a class="btn mr-1 mb-1 btn-outline-primary btn-block" href="#" @click="sendSms(value.DigitableLine)"><i class="fa fa-fw fa-mobile"></i>&nbsp;Receber por SMS</a>
                         <a class="btn mr-1 mb-2 btn-outline-primary btn-block" href="#" @click="sendEmail(value.DigitableLine)"><i class="fa fa-fw fa-envelope-o"></i>&nbsp;Receber por e-mail</a>
                        </div>
                         <a class="btn mr-1 mb-1 mt-2 btn-outline-primary btn-block" href="#" @click.prevent="downloadInvoiceBoleto(value)"><i class="fa fa-download fa-fw"></i>&nbsp;Baixar boleto</a>
                        </div>
                        </div>
                       <hr>
                     </div>
                   </div>
               </div>  
             </div>
                          </div>
                          </div>
                          </div>
       </div>
       <div class="d-flex-center flex-wrap flex-column col-lg-7" v-if="!showOtherContracts && !Array.isArray(responseFromAgreement) && !loadDeal && responseFromAgreement.PRESTACOES">
         <div class="card" v-if="!isEmpty(responseFromAgreement)">
           <div class="card-header">
             <i class="fa fa-fw mr-2 fa-circle text-warning"></i>
             Boleto ativo
           </div>
           <div class="card-body">
             <div class="row">
               <div class="col-md-12">
                 <h6 class="mb-4">Acordo: {{  this.responseFromAgreement.PRESTACOES.PREST[0].DESCONTR }}</h6> 
                 <hr>
                 <div class="row col-12 align-items-center justify-content-end">
                 <div class="col-md-12 col-lg-8">
                     <!-- <h6 class="mb-4">Acordo {{ installment.acordo }}</h6>  -->
                     <p class="m-0 text-info">Vencimento:</p>
                     <h6>{{ formatData(this.responseFromAgreement.PRESTACOES.PREST[0].DATVENCI, "YYYY-MM-DD", "DD/MM/YYYY") }}</h6>
                   </div>
                   <div class="col-lg-4 col-12 align-self-end">
                     <p>Valor: R$ {{ this.responseFromAgreement.PRESTACOES.PREST[0].VALPAGO }}</p>
                   </div>
                   <!-- <pre>{{ responseFromAgreement[value] }}</pre> -->
                   <div class="col-12">
                     <div class="row col-12"></div>
                       <!-- <p class="" style="color: #2c6a8a;">Acordo formalizado fora do portal negociação</p> -->
                     </div>
                     <p class="text-info mb-1 col-12">Linha digitável:</p>
                     <p class="codebar col-12" id="linhaDigitavel">{{ responseFromAgreement.DADOBOLETO[0].LINHADIGITAVEL }}</p>
                     <a class="btn mr-1 mb-1 btn-outline-primary btn-block" href="#" @click="copiarLinhaDigitável(responseFromAgreement.DADOBOLETO[0].LINHADIGITAVEL)"><i class="fa fa-copy fa-fw"
                       @click="copiarLinhaDigitável(responseFromAgreement.DADOBOLETO[0].LINHADIGITAVEL)"></i>&nbsp;Copiar linha digitável</a>
                       <a class="btn mr-1 mb-1 btn-outline-primary btn-block" href="#" @click="generatePDF(responseFromAgreement.DADOBOLETO[0].BASE64)" ><i class="fa fa-download fa-fw"></i>&nbsp;Baixar boleto</a>
                       <a class="btn mr-1 mb-1 btn-outline-primary btn-block" href="#" @click="sendSms(responseFromAgreement.DADOBOLETO[0].LINHADIGITAVEL)"><i class="fa fa-fw fa-mobile"></i>&nbsp;Receber por SMS</a>
                       <a class="btn mr-1 mb-1 btn-outline-primary btn-block mb-4" href="#" @click="sendEmail(responseFromAgreement.DADOBOLETO[0].LINHADIGITAVEL)"><i class="fa fa-fw fa-envelope-o"></i>&nbsp;Receber por e-mail</a>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
         <div v-if="contractsValidateDate.length > 0">
         <div class="m-auto col-lg-7" v-if="isDateBiggerThanSixDays(contractsValidateDate[0].parcelas[0].vencimento.split('T')[0]) && !showOtherContracts && Array.isArray(responseFromAgreement) && !loadDeal && !loadSegundaViaBoleto && !loadInstallment">
          <div v-for="(value, key, index) in responseFromAgreement"
                           :key="`${key}-${index}`">
         <div class="card">
           <div class="card-header">
             <i class="fa fa-fw mr-2 fa-circle text-warning"></i>
             Boleto ativo
           </div>
           <div class="card-body">
             <div class="row">
               <div class="col-md-12">
                 <h6 class="mb-4">Acordo: {{  value.CodParce }}</h6> 
                 <hr>
                 <div class="row col-12 align-items-center justify-content-end">
                 <div class="col-md-12 col-lg-8">
                     <p class="m-0 text-info">Vencimento:</p>
                     <h6>{{ formatData(value.DueDate, "YYYY-MM-DD", "DD/MM/YYYY") }}</h6>
                   </div>
                   <div class="col-lg-4 col-12 align-self-end">
                     <p>Valor: R$ {{ value.Value }}</p>
                   </div>
                   <div class="col-12">
                     <div class="row col-12"></div>
                     </div>
                     <p class="text-info mb-1 col-12">Linha digitável:</p>
                     <p class="codebar col-12" id="linhaDigitavel">{{ value.DigitableLineID }}</p>
                     <a class="btn mr-1 mb-1 btn-outline-primary btn-block" href="#" @click="copiarLinhaDigitável(value.DigitableLineID)"><i class="fa fa-copy fa-fw"
                       @click="copiarLinhaDigitável(value.DigitableLineID)"></i>&nbsp;Copiar linha digitável</a>
                       <a class="btn mr-1 mb-1 btn-outline-primary btn-block" href="#" @click="generatePDF(value.Base64String)" ><i class="fa fa-download fa-fw"></i>&nbsp;Baixar boleto</a>
                       <a class="btn mr-1 mb-1 btn-outline-primary btn-block" href="#" @click="sendSms(value.DigitableLineID)"><i class="fa fa-fw fa-mobile"></i>&nbsp;Receber por SMS</a>
                       <a class="btn mr-1 mb-1 btn-outline-primary btn-block mb-4" href="#" @click="sendEmail(value.DigitableLineID)"><i class="fa fa-fw fa-envelope-o"></i>&nbsp;Receber por e-mail</a>
                   </div>
                 </div>
               </div>
             </div>
           </div>
           </div>
         </div>
         </div>
       </div>
     </div>
     <!-- <div class="container" v-if="loadSegundaViaBoleto || loadInstallment || loadDeal">
      <ProgressLoading v-bind:loading="loadSegundaViaBoleto || loadInstallment || loadDeal" />
    </div> -->
 </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatCurrencieValueBRL as formatValue, formatData, formatDocument } from "@/utils/helpers";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";

export default {
   name: "HistoricoPagamentos",
    components: {
     ProgressLoading
   },
   data () {
       return {
           loadDeal: false,
           loadSegundaViaBoleto: false,
           // agreement: null,
           contract :null,
           selectDeal:null,
           digitalLine:null,
           valorParcela: null,
           contractFull: null,
           checkSelectAll: false,
           checkContract: false,
           links: [],
           loadInstallment: false,
           showOtherContracts: false,
           responseFromAgreement: {},
           largura: null,
           firstCall: true,
           userAdm: {},
           ipUser: null
       }
   },
   methods: {
       formatValue,
       formatData,
       formatDocument,

       ...mapActions('minhasDividas', [
         'ActionSendEmailOrSmsText',
         'ActionDownloadBoleto',
         'ActionGetInstallmentsTribanco',
         'ActionDownloadBoletoSegundaVia',
         'ActionLogDownloadBoleto',
         'ActionLogCopyDigitableLine',
       ]),

       showOthersBilss() {

          if(this.contractsValidateDate.length > 0) {
            if (this.isDateBiggerThanSixDays(this.contractsValidateDate[0].parcelas[0].vencimento.split('T')[0]) && this.firstCall) {
              this.showOtherContracts = false;
              this.firstCall = false;
              return;
            }
          }

         if (!this.showOtherContracts && !this.firstCall && this.onlyContractsSecondInvoice.length <= 0 && !this.contractsUpdated) {
           this.showOtherContracts = true;
         } else {
           this.showOtherContracts = false;
         }
           this.firstCall = false;
       },

       async buildNewBill(contract, key, installment, fromInstallment = false) {
        this.valorParcela =
        typeof installment.valor === "undefined"
          ? installment.value
          : installment.valor;

         if (!fromInstallment) {
          this.loadDeal = true
         }
         this.loadInstallment = true;
         try {
          let dueDate = new Date().toJSON().split("T")[0]
          if(installment.vencimento >=  dueDate){
            dueDate = installment.vencimento
          }

           const { credor, contrato, company, produto } = contract

           if(credor == 1){
            let data = new Date();
            data.setDate(data.getDate() + 5);
            dueDate = data.toJSON().split("T")[0];
           }

           const jsonToBill = {
             document: this.regis,
             credor,
             company,
             installments: [
               {
                 product: produto ? produto : 'PARC',
                 contract: contrato,
                 dueInstallmentDate: installment.vencimento
               }
             ],
             dueDate,
             tag: localStorage.getItem('tag'),
             UserID: this.userAdm ? this.userAdm.UserID : null,
             UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
             OS:navigator.platform,
             IP: this.ipUser ? this.ipUser : '',
           }
           const resp = await this.ActionDownloadBoleto(jsonToBill)
           this.generatePDF(resp.DADOBOLETO[0].BASE64) 
           await this.delay(9000)
             this.responseFromAgreement = resp

             

           // eslint-disable-next-line
           // debugger;
           // this.responseFromAgreement = await this.ActionGetInstallmentsTribanco();
           // this.responseFromAgreement = await this.handleAgreements(this.responseFromAgreement);
           // if(this.isEmpty(this.responseFromAgreement) && this.contracts.length === 1) {
            //  this.showOthersBilss();
           // }
           this.loadInstallment = false;
           this.loadDeal = false
         } catch {
           this.flashMessage.show({
             timeout: 1000,
             status: "error",
             title: "Ocorreu um erro",
             message: "Nenhum usuário foi encontrado!",
           });
           this.loadInstallment = false;
           this.loadDeal = false
         }
       },

       async boletoSegundaVia(contract, installment, option) {
         this.loadSegundaViaBoleto = true;
        this.valorParcela =
        typeof installment.valor === "undefined"
          ? installment.value
          : installment.valor;

         this.loadInstallment = true;
         try {
          let dueDate = new Date().toJSON().split("T")[0]
          if(installment.vencimento >=  dueDate){
            dueDate = installment.vencimento
          }

           const { credor, contrato, company, produto } = contract

           if(credor == 1){
            let data = new Date();
            data.setDate(data.getDate() + 5);
            dueDate = data.toJSON().split("T")[0];
           }

           const jsonToBill = {
             document: this.regis,
             credor,
             company,
             installments: [
               {
                 product: produto ? produto : 'PARC',
                 contract: contrato,
                 dueInstallmentDate: installment[0].vencimento,
                 option: option,
               }
             ],
             dueDate,
             tag: localStorage.getItem('tag'),
             UserID: this.userAdm ? this.userAdm.UserID : null,
             UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
             OS:navigator.platform,
             IP: this.ipUser ? this.ipUser : '',
           }
           const resp = await this.ActionDownloadBoletoSegundaVia(jsonToBill)
           this.generatePDF(resp.DADOBOLETO[0].BASE64) 
           await this.delay(9000)
             this.responseFromAgreement = resp
           this.loadInstallment = false;
           this.loadSegundaViaBoleto = false
         } catch {
           this.flashMessage.show({
             timeout: 1000,
             status: "error",
             title: "Ocorreu um erro",
             message: "Nenhum usuário foi encontrado!",
           });
           this.loadInstallment = false;
           this.loadSegundaViaBoleto = false
         }
       },

       formattedValue(value) {
         return value
       },

       generatePDF(value) {
         const linkSource = `data:application/pdf;base64,${value}`;
         const downloadLink = document.createElement("a");
         downloadLink.setAttribute('target', '_blank');
         const fileName =  "boleto-parcela.pdf";
         downloadLink.href = linkSource;
         downloadLink.download = fileName;
         downloadLink.click();
         this.logDownloadBoleto();
       },

       downloadInvoiceBoleto(value) {
         if (!value?.DownloadLink) return;
         window.open(value.DownloadLink, '_blank', 'noopener,noreferrer');
         this.logDownloadBoleto({
           digitableLine: value.DigitableLine,
         });
       },

       logDownloadBoleto(extra = {}) {
         this.ActionLogDownloadBoleto({
           IP: this.ipUser || '',
           OS: typeof navigator !== 'undefined' ? navigator.platform : '',
           UserID: this.userAdm ? this.userAdm.UserID : null,
           UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
           digitableLine: extra.digitableLine,
           contrato: extra.contrato,
           NotesJson: {
             action: 'download_boleto',
             digitableLine: extra.digitableLine || undefined,
             contrato: extra.contrato || undefined,
             downloadedAt: new Date().toISOString(),
           },
         });
       },

       delay(time) {
         return new Promise(resolve => setTimeout(resolve, time));
       },

       async sendSms(LinhaDigitavel) {
         this.loadDeal = true;

         try {
           await this.ActionSendEmailOrSmsText({
             LinhaDigitavel,
             Email: '',
             PhoneNumber: this.user.MobileNumber ? this.user.MobileNumber : this.user.PhoneNumber,
             type: 'sms',
             UserID: this.userAdm ? this.userAdm.UserID : null,
             UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
             OS:navigator.platform,
             IP: this.ipUser ? this.ipUser : '',
           });
           this.loadDeal = false;

           this.flashMessage.show({
             timeout:1000,
             blockClass: 'custom-block-class',
             status: 'success', 
             title: 'Sucesso', 
             message: 'Linha digitável enviado por sms com sucesso'});
         } catch {
           this.flashMessage.show({
             timeout: 1000,
             status: "error",
             title: "Ocorreu um erro",
             message: "Nenhum usuário foi encontrado!",
           });
           this.loadDeal = false;
         }
       },

       async sendEmail(LinhaDigitavel) {
         this.loadDeal = true;

         try {
           await this.ActionSendEmailOrSmsText({
             LinhaDigitavel,
             Email: this.user.Email,
             PhoneNumber: '',
             type: 'email',
             UserID: this.userAdm ? this.userAdm.UserID : null,
             UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
             OS:navigator.platform,
             IP: this.ipUser ? this.ipUser : '',
           });
           this.loadDeal = false;

           this.flashMessage.show({
             timeout:1000,
             blockClass: 'custom-block-class',
             status: 'success', 
             title: 'Sucesso', 
             message: 'Linha digitável enviado por e-mail com sucesso'});
         } catch {
           this.loadDeal = false;
         }
       },

       copiarLinhaDigitável(linhaDigitavel){
         const elem = document.createElement("textarea");
         elem.value = linhaDigitavel;
         document.body.appendChild(elem);
         elem.select();
         document.execCommand("copy");
         document.body.removeChild(elem);

         this.ActionLogCopyDigitableLine({
           IP: this.ipUser || '',
           OS: typeof navigator !== 'undefined' ? navigator.platform : '',
           UserID: this.userAdm ? this.userAdm.UserID : null,
           UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
           digitableLine: linhaDigitavel,
           NotesJson: {
             action: 'copy_digitable_line',
             digitableLine: linhaDigitavel || undefined,
             copiedAt: new Date().toISOString(),
           },
         });

         this.flashMessage.show({
           timeout: 1000,
           status: "success",
           title: "Sucesso",
           blockClass: "custom-block-class",
           message: "Linha digitável foi copiada para o seu clipboard",
         });
       },

       deactivated() {
           this.divida = null;
           this.negociacao = null;
           this.selectDeal = null;
           this.digitalLine = null;
       },
       voltar() {
            this.$router.push({ 
              name: 'dashboard',
             });
       },
       showDigitalLine(){
         this.digitalLine = this.selectDeal.linhaDigitavel;
       },

       selectAll() {
             var marcar = document.getElementById('all').checked;
             var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
             for (var i = 0; i < lista.length; i++) {
               lista[i].checked = marcar;
             }
       },

       select() {
         var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
         var all = document.getElementById('all');
         if(lista.length <= 2) {
           all.checked = false;
         }
       },

       clear() {
             var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
             for (var i = 0; i < lista.length; i++) {
               lista[i].checked = false;
             }
       },

       handleAgreements(agreements) {
         let aux = []
         let obj = {}
         agreements.map((value) => {
           if (!aux.includes(value.CodParce)) {
             aux.push(value.CodParce)
             obj[value.CodParce] = {
               contrato: value.CodParce,
               installments: [{
                   base64: value.Base64String,
                   digitableLine: value.DigitableLineID,
                   dueDate: value.DueDate,
                   value: value.Value,
                   source: value.Source
                 }
               ]
             }
           } else {
             obj[value.CodParce].installments.push({
               base64: value.Base64String,
               digitableLine: value.DigitableLineID,
               dueDate: value.DueDate,
               value: value.Value,
               source: value.Source
             })
           }
         })
         return obj
       },

       isDateBiggerThanSixDays (date) {
         let parts = date.split('-') 
         let debtDate = new Date(date);
         let today = new Date()    
         
         date = new Date(parts[0], parts[1] - 1, parts[1])
         return (Math.floor((today - debtDate) / (1000 * 60 * 60 * 24))) >= 6 ? true : false;
         
       },

       datePlusDocIsBiggerThanAgreementDate (dateMaisDoc, dateAgreement) {
          let maisDoc = new Date(dateMaisDoc);    
          let agreement = new Date(dateAgreement);   

          return maisDoc > agreement ? true : false;
        },

        datePlusDocIsSmallerThan30Days (dateMaisDoc) {
          let maisDoc = new Date(dateMaisDoc);    
          let today = new Date();   
          return (Math.floor((today - maisDoc) / (1000 * 60 * 60 * 24))) < 30 ? true : false;
        },

        dateIsBetweenSixAnd67Days (date) {
          let dateBill = new Date(date);    
          let today = new Date();   
          let delayedDays = (Math.floor((today - dateBill) / (1000 * 60 * 60 * 24)));
          return delayedDays >= 6 && delayedDays <= 67 ? true : false;
        },

       contractsFilter() {
         this.contracts = this.contracts.map((contract) => {
           const parcelas = contract.parcelas.filter((installment) => {
             let aux = true
             this.responseFromAgreement.map((dbData) => {
               if (installment.vencimento === dbData.DueDate && installment.valor === dbData.Value) {
                 aux = false
               }
             })
             return aux
             })
           if (parcelas) return { ...contract, parcelas}
         })
         this.contracts = this.contracts?.filter((contract) => {
           return contract.parcelas.length > 0
         })
       },

        isEmpty(obj) {
         return Object.keys(obj).length === 0;
       }

       
   },
   async created() {
     this.ipUser = localStorage.getItem('ipUser');
     this.userAdm = JSON.parse(localStorage.getItem("userAdm"));
     this.largura = window.screen.width; 
     this.loadDeal = true;
     this.responseFromAgreement = this.$route.params.responseFromAgreement ? this.$route.params.responseFromAgreement : [];
     

     this.onlyContractsSecondInvoice = this.$route.params.onlyContractsSecondInvoice ? this.$route.params.onlyContractsSecondInvoice : [];
     this.segundaViaBoleto = this.$route.params.segundaViaBoleto;
     this.option = this.$route.params.option;

     this.contracts = JSON.parse(localStorage.getItem('contracts'))
     this.contractsValidateDate = JSON.parse(localStorage.getItem('contracts'))
     this.contractsInvoices = JSON.parse(localStorage.getItem('contractsInvoices'))
     this.contractsUpdated = JSON.parse(localStorage.getItem('contractsUpdated'));

     if(this.contractsUpdated !== null) {
       this.contracts = this.contracts.length === 0 ? this.contractsUpdated : this.contracts;
     } 

      this.regis = this.contracts.length > 0 ? this.contracts[0].regis : null
      this.contracts = this.contracts?.filter((value) => {
        return (value.produto === 'PARC')
      })

    if(this.segundaViaBoleto && !this.isEmpty(this.responseFromAgreement)) {
          this.boletoSegundaVia(this.responseFromAgreement, this.responseFromAgreement.parcelas, this.option);
    }


     if(this.onlyContractsSecondInvoice && this.contractsUpdated !== null && !this.segundaViaBoleto) {
       this.responseFromAgreement.map((contract, index) => {
         contract.parcelas.map((installments) => {
          this.buildNewBill(contract, index, installments);
         });
       });
     }

     this.showOthersBilss();
     this.loadDeal = false;


   },
   computed: {
     ...mapState("auth", ["user"]),
     isLoggedIn() {
     return this.$store.getters["auth/isLoggedIn"];
   },
   }
};
</script>
